import { createContext } from '@shared/utils/createContext';
import type { ScoreBreakdown } from '@shared/utils/search';

/**
 * Group key → the winning colorway row's score breakdown. The key is typically
 * a `StationeryTemplate.id` (value props use `valueprop_<telemetryId>`); see
 * `getGroupKey`.
 */
type GallerySearchScores = ReadonlyMap<string, ScoreBreakdown>;

/**
 * Per-tile search score breakdowns, populated only when the `showSearchScores`
 * debug flag is on and a search is active. Tiles read their own entry to render
 * the similarity readout under the title.
 *
 * `strict: false` because the context is intentionally absent outside the
 * designs gallery (e.g. favorites), where tiles render no scores at all.
 */
const [GallerySearchScoresProvider, useGallerySearchScoresContext] = createContext<GallerySearchScores>({
  name: 'GallerySearchScoresContext',
  strict: false,
});

export { GallerySearchScoresProvider };

export function useGallerySearchScore(key: string): ScoreBreakdown | undefined {
  return useGallerySearchScoresContext()?.get(key);
}
